import {
  PracticeTherapyDepartment,
  PracticeTreatmentContracts,
  PracticeTreatmentContractType,
  TreatmentContractEntry,
} from "@physiofit-digital/physiofit_types";

type TreatmentContractsMap =
  | Partial<Record<PracticeTreatmentContractType, TreatmentContractEntry>>
  | undefined;

const pairedInsuranceCostBearers: PracticeTreatmentContractType[] = [
  "statutoryHealthInsurance",
  "privateHealthInsurance",
];

const orderedCostBearerKeys: PracticeTreatmentContractType[] = [
  "statutoryHealthInsurance",
  "privateHealthInsurance",
  "professionalAssociation",
  "army",
  "selfPayer",
  "federalAid",
  "stateAid",
  "pensionInsurance",
];

export const hasTreatmentContractDocument = (
  contract?: TreatmentContractEntry,
) => Boolean(contract?.mergedFileUrl?.trim());

export const getVisibleCostBearers = (
  contracts?: TreatmentContractsMap,
): PracticeTreatmentContractType[] => {
  const hasEnabledDocument = (costBearerKey: PracticeTreatmentContractType) =>
    !contracts?.[costBearerKey]?.disabled &&
    hasTreatmentContractDocument(contracts?.[costBearerKey]);

  const shouldShowPairedInsuranceOptions =
    pairedInsuranceCostBearers.some(hasEnabledDocument);

  return orderedCostBearerKeys.filter((costBearerKey) => {
    // Either insurance stays pickable when only its partner has a document
    if (pairedInsuranceCostBearers.includes(costBearerKey)) {
      return (
        shouldShowPairedInsuranceOptions &&
        !contracts?.[costBearerKey]?.disabled
      );
    }

    return hasEnabledDocument(costBearerKey);
  });
};

export const getDepartmentsWithVisibleCostBearers = (
  practiceTreatmentContracts: PracticeTreatmentContracts["practiceTreatmentContracts"],
): PracticeTherapyDepartment[] =>
  (
    Object.keys(practiceTreatmentContracts ?? {}) as PracticeTherapyDepartment[]
  ).filter(
    (department) =>
      getVisibleCostBearers(practiceTreatmentContracts?.[department]?.contracts)
        .length > 0,
  );
